import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Tax } from '../../../models/tax';

import { TaxService } from '../../../services/accounting/tax.service';
import { UserService } from '../../../services/users/user.service';

@Component({
  selector: 'app-tax-index',
  templateUrl: './tax-index.component.html',
  styleUrls: ['./tax-index.component.scss'],
})
export class TaxIndexComponent implements OnInit {
  count: number = 0;

  loading: boolean = true;

  taxes: Array<Tax> = [];

  constructor(private router: Router, private taxService: TaxService, private userService: UserService) {}

  //Component lifecycle events
  ngOnInit() {
    this.userService.navbarComponent.setTaxesMenu();
    this.loadTaxes();
  }

  // Component methods
  loadTaxes() {
    this.loading = true;
    this.taxService
      .index()
      .then((response_json) => {
        this.loading = false;
        this.count = response_json.count;
        this.taxes = response_json.taxes;
      })
      .catch(() => {
        this.loading = false;
      });
  }

  openNewTax() {
    this.router.navigateByUrl('/taxes/new');
  }
}
